import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 20223-09-07
 * @brief SEI 메뉴 관리 개발
 *
 ********************************************************************/
//utils
//component
import AuthSetting from "./AuthSetting";
import MenuTree from "./MenuTree";
function MenuMain() {
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "box-wrap" }, { children: [_jsx(MenuTree, {}), _jsx(AuthSetting, {})] })) }));
}
export default MenuMain;
